import { ValidationError } from '@dte/otw-utils-validation/src/ValidationError';

import { validateRequiredNumericString } from './validateNumericString';

export function validateRequiredPremiseId(premiseId: string | number | undefined): string {
	const value = validateRequiredNumericString('Premise Id', premiseId, 10, 10, {
		no_symbols: true,
	});

	// Must start with 5
	if (!value.startsWith('5')) {
		throw new ValidationError('Premise Id should start with a 5');
	}

	return value;
}

export function validateOptionalPremiseId(premiseId: string | number | undefined): string | undefined {
	try {
		return validateRequiredPremiseId(premiseId);
	} catch (error) {
		// Allow for undefined values, but rethrow if an invalid value was provided
		if (premiseId) {
			throw error;
		}
		return undefined;
	}
}

export function isValidPremiseId(premiseId: string | number | undefined): boolean {
	try {
		const value = validateRequiredPremiseId(premiseId);
		return value !== undefined;
	} catch {
		return false;
	}
}
